import { DatabaseConnectionManager } from "@/domains/database/core/database-connection-manager";
import { SmartContextRepository } from "./smart-context-repository";
import { SmartViewRepository } from "./smart-view-repository";
import { SmartCardRepository } from "./smart-card-repository";
import { StatsRepository } from "./stats-repository";

export interface RepositorySet {
  smartContexts: SmartContextRepository;
  smartViews: SmartViewRepository;
  smartCards: SmartCardRepository;
  stats: StatsRepository;
}

export function createRepositories(connectionManager: DatabaseConnectionManager): RepositorySet {
  return {
    smartContexts: new SmartContextRepository(connectionManager),
    smartViews: new SmartViewRepository(connectionManager),
    smartCards: new SmartCardRepository(connectionManager),
    stats: new StatsRepository(connectionManager),
  };
}
